import { useTranslation } from 'react-i18next';

import {
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { ArrowLeft, Plus, Upload } from 'lucide-react';

import { BaseImportViewProps } from './import-view-props';

export const ViewCouponsMenu: React.FC<BaseImportViewProps> = ({
  setImportView,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <DialogHeader>
        <div className="flex items-center gap-2">
          <button
            className="rounded-md p-1 hover:bg-muted"
            onClick={() => setImportView('chooser')}
            aria-label="Revenir au choix"
          >
            <ArrowLeft className="h-4 w-4" />
          </button>
          <DialogTitle>
            {t('components.import_flow.coupons_menu.title')}
          </DialogTitle>
        </div>
        <DialogDescription>
          {t('components.import_flow.coupons_menu.description')}
        </DialogDescription>
      </DialogHeader>
      <div className="mt-6 space-y-3">
        <button
          className="flex w-full items-center gap-4 rounded-lg border p-4 hover:bg-muted"
          onClick={() => setImportView('couponsManual')}
        >
          <div className="flex h-12 w-12 items-center justify-center rounded-md bg-muted">
            <Plus className="h-6 w-6" />
          </div>
          <div className="flex flex-col text-left">
            <div className="text-base font-medium">
              {t('components.import_flow.coupons_menu.create_manually')}
            </div>
          </div>
        </button>
        <button
          className="flex w-full items-center gap-4 rounded-lg border p-4 hover:bg-muted"
          onClick={() => setImportView('couponsImport')}
        >
          <div className="flex h-12 w-12 items-center justify-center rounded-md bg-muted">
            <Upload className="h-6 w-6" />
          </div>
          <div className="flex flex-col text-left">
            <div className="text-base font-medium">
              {t('general.import_csv_file')}
            </div>
          </div>
        </button>
      </div>
    </>
  );
};
